<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fmtitle"><a id="page_vi"></a><a id="page_vii"></a><b>Contents</b></h1>
<p class="toc"><a href="#/html/06_9780813121307_Preface">Preface</a></p>
<p class="toc"><a href="#/html/07_9780813121307_Intro">Introduction</a></p>
<p class="toc3">George F. Hofmann and Donn A. Starry</p>
<p class="toc1"><a href="#/html/08_9780813121307_Chapter01">1<span class="pad1"></span>World War I The Birth of American Armor</a></p>
<p class="toc3">Dale E. Wilson</p>
<p class="toc1"><a href="#/html/09_9780813121307_Chapter02">2<span class="pad1"></span>Organizational Milestones in the Development of American Armor, 1920-40</a></p>
<p class="toc3">Timothy K. Nenninger</p>
<p class="toc1"><span href="#/html/10_9780813121307_Chapter03" title="Link target outside of Sample">3<span class="pad1"></span>The Marine Corps’s First Experience with an Amphibious Tank</span></p>
<p class="toc3">George F. Hofmann</p>
<p class="toc1"><span href="#/html/11_9780813121307_Chapter04" title="Link target outside of Sample">4<span class="pad1"></span>Army Doctrine and the Christie Tank Failing to Exploit the Operational Level of War</span></p>
<p class="toc3">George F. Hofmann</p>
<p class="toc1"><span href="#/html/12_9780813121307_Chapter05" title="Link target outside of Sample">5<span class="pad1"></span>World War II Armor Operations in Europe</span></p>
<p class="toc3">Christopher R. Gabel</p>
<p class="toc1"><span href="#/html/13_9780813121307_Chapter06" title="Link target outside of Sample">6<span class="pad1"></span>Marine Corps Armor Operations in World War II </span></p>
<p class="toc3">Joseph H. Alexander</p>
<p class="toc1"><span href="#/html/14_9780813121307_Chapter07" title="Link target outside of Sample">7<span class="pad1"></span>Post-World War II and Korea Paying for Unpreparedness</span></p>
<p class="toc3">Philip L. Bolté</p>
<p class="toc1"><span href="#/html/15_9780813121307_Chapter08" title="Link target outside of Sample">8<span class="pad1"></span>The Marine Corps’s Struggle with Armor Doctrine during the Cold War (1945-70)</span></p>
<p class="toc3">Kenneth W. Estes</p>
<p class="toc1"><span href="#/html/16_9780813121307_Chapter09" title="Link target outside of Sample">9<span class="pad1"></span>The Patton Tanks The Cold War Learning Series</span></p>
<p class="toc3"><a id="page_viii"></a>Oscar C. Decker</p>
<p class="toc2"><span href="#/html/17_9780813121307_Chapter10" title="Link target outside of Sample">10<span class="pad1"></span>Adaptation and Impact Mounted Combat in Vietnam</span></p>
<p class="toc3">Lewis Sorley</p>
<p class="toc2"><span href="#/html/18_9780813121307_Chapter11" title="Link target outside of Sample">11<span class="pad1"></span>AirLand Battle</span></p>
<p class="toc3">Richard M. Swain</p>
<p class="toc2"><span href="#/html/19_9780813121307_Chapter12" title="Link target outside of Sample">12<span class="pad1"></span>“Lethal beyond all expectations” The Bradley Fighting Vehicle</span></p>
<p class="toc3">Diane L. Urbina</p>
<p class="toc2"><span href="#/html/20_9780813121307_Chapter13" title="Link target outside of Sample">13<span class="pad1"></span>The Abrams Tank System</span></p>
<p class="toc3">Robert J. Sunell</p>
<p class="toc2"><span href="#/html/21_9780813121307_Chapter14" title="Link target outside of Sample">14<span class="pad1"></span>The Approach of Mounted Warfare in the Marine Corps (1970-95)</span></p>
<p class="toc3">Kenneth W. Estes</p>
<p class="toc2"><span href="#/html/22_9780813121307_Chapter15" title="Link target outside of Sample">15<span class="pad1"></span>The Hundred-Hour Thunderbolt Armor in the Gulf War</span></p>
<p class="toc3">Stephen A. Bourque</p>
<p class="toc2"><span href="#/html/23_9780813121307_Chapter16" title="Link target outside of Sample">16<span class="pad1"></span>Reflections</span></p>
<p class="toc3">Donn A. Starry</p>
<p class="toc"><span href="#/html/24_9780813121307_References" title="Link target outside of Sample">Select Bibliography</span></p>
<p class="toc"><span href="#/html/25_9780813121307_About_The_Author" title="Link target outside of Sample">About the Editors and Contributors</span></p>
<p class="toc"><span href="#/html/26_9780813121307_Index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_9780813121307_Contents.vue?11dbe478